import { User } from 'lucide-react'
import { ProfileSettings } from '@/components/settings/profile-settings'

export default function ProfilePage() {
  return (
    <div className="container max-w-2xl py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center">
          <User className="h-8 w-8 mr-3" />
          Profiel Bewerken
        </h1>
        <p className="text-gray-600">
          Beheer je profielinformatie, privacy instellingen en persoonlijke gegevens.
        </p>
      </div>

      <div className="space-y-6">
        <ProfileSettings />
      </div>
    </div>
  )
}